import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { AuthStore } from '@root/app/store/auth.store';
import { AuthService } from '../../../core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationContainerComponent } from '../authorization-container/authorization-container.component';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_PATHS } from '@core/constants';
import { MatIcon } from '@angular/material/icon';
import { FilledButtonComponent } from '@custom-components/general/button/filled-button/filled-button.component';
import { AlertBannerComponent } from '@custom-components/feedback/alert-banner/alert-banner.component';

@Component({
  selector: 'xemex-join-network-page',
  imports: [
    MatIcon,
    TranslateModule,
    AuthorizationContainerComponent,
    FilledButtonComponent,
    AlertBannerComponent,
  ],
  standalone: true,
  providers: [AuthService],
  templateUrl: './join-network-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './join-network-page.component.scss',
})
export class JoinNetworkPageComponent {
  readonly store = inject(AuthStore);

  token: string = '';
  partnerName: string = '';

  readonly hasJoined = computed(() => this.store.authFeedback()?.variant === 'success');

  constructor(
    readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.store.clearAuthFeedback();
    this.token = this.route.snapshot.queryParamMap.get('t') ?? '';
    this.partnerName = this.route.snapshot.queryParamMap.get('partnerName') ?? '';
    const expiry = this.route.snapshot.queryParamMap.get('e');

    // A link with no token can never be accepted, so treat it the same as an expired one
    // rather than leaving a button that silently does nothing.
    if (!this.token || (expiry && new Date(atob(expiry)) < new Date())) {
      this.router.navigate(['/', APP_PATHS.Auth, APP_PATHS.LinkExpired]);
    }
  }

  onJoinNow() {
    if (!this.token) {
      return;
    }
    this.store.joinNetwork(this.token);
  }

  backToLogin() {
    this.router.navigate(['/', APP_PATHS.Auth, APP_PATHS.Login]);
  }
}
